import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})

export class ProductSubCategoryService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    saveSubCategory(categoryData: any) {
        const url = `${API_URLBLAZE}/product/product-subcategory`;
        return this.http.post(url, categoryData).pipe(catchError(this.handleError()));
    }

    updateSubCategory(categoryData: any) {
      const url = `${API_URLBLAZE}/product/product-subcategory/edit`;
      return this.http.post(url, categoryData).pipe(catchError(this.handleError()));
    }

    getSubCategoryList(categoryName : String,subCategoryName:String,status:String,page_size:number,page_no:number,sort : any,columnName : any) {
      var url = "";
      var filter = "";
      if(categoryName != ""){
        filter = filter+`&productCategory.name=${categoryName}`
      }
      if(subCategoryName != ""){
        filter = filter+`&name=${subCategoryName}`
      }
      if(status != ""){
        filter = filter+`&status=${status}`
      }
      if(sort != ""){
        filter = filter+`&sort_dir=${sort}`
      }
      if(columnName != ""){
        filter = filter+`&sort_column=${columnName}`
      }

      url = `${API_URLBLAZE}/product/product-subcategory?page_size=${page_size}&page_no=${page_no}`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getSubCategoryById(id: number) {
      const url = `${API_URLBLAZE}/product/product-subcategory/`+id;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getCategoryDropdown() {
      const url = `${API_URLBLAZE}/product/product-category/list`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }


      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}